import { Auth0Provider as Auth0WebProvider } from "@auth0/auth0-react"
import React from "react"
import { extra } from "../../../config"

const Auth0Provider = ({ children }: { children: React.ReactNode }): JSX.Element => {
  return (
    <Auth0WebProvider
      domain={extra.REACT_APP_AUTH0_DOMAIN}
      clientId={extra.REACT_APP_AUTH0_CLIENT_ID}
      authorizationParams={{
        redirect_uri: `${extra.webappUrl}/callback`,
        audience: extra.REACT_APP_AUTH0_AUDIENCE
      }}
      onRedirectCallback={async (appState) => {
        if (appState && appState.target) {
          // set url to be the target path
          window.history.pushState(null, '', appState.target)
        }
      }}
    >
      {children}
    </Auth0WebProvider>
  )
}

export default Auth0Provider